import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.season || initialState;

export const selectSeason = createSelector([selectSlice], state => state);

export const selectIsSeasonsLoaded = createSelector([selectSeason], state =>
  Boolean(state.seasons),
);

export const selectAllSeasons = createSelector(
  [selectSeason],
  state => state.seasons,
);
export const selectSelectedSeasonId = createSelector(
  [selectSeason],
  state => state.selectedSeasonId,
);
